import MaterialTable from "material-table";
import React from "react";
import { useTranslation } from "react-i18next";
import {TableIcons as tableIcons} from "../../../../Elemnts/TableIcons";
import { colors } from "@material-ui/core";

const ItemsInvTable=(props)=>{

    const {t} = useTranslation(['forms'])
      const {
        classesInfo,
        cuRows,
        permiCuCo,
        setting,
        Mtb,
        stElemnt,
        AutoOptions,
        onRowClicks,
        isPurches,
        isStock,
        post
    } = props;
   const itmData= cuRows.map((su) => {
        var groupName = AutoOptions.groups.find((x) => x.id === su.group_id);
        return { ...su, nameG: groupName ? groupName.name : "" };
      });



     var columnsCurr = [
      {title: t('sale-price'), field: "sale_price", hidden:
      (setting.PrTy_InPr=="01" || setting.PrTy_InPr=="11")||post==2
     },
      {title: t('purch-price'), field: "purch_price", hidden: 
     ( permiCuCo.HPP && ["12","02","03","149", "150"].includes(setting.PrTy_InPr) )||post==2
     },
      {title: t('product-group'), field: "nameG",},
      {title: t('barcode'), field: "barcode",},
      {title: t('item-name'), field: "symbol",},
    ]


    return (
         <MaterialTable className={classesInfo.noScroll} style={{boxShadow:'none'}}
                // variant="outlined"
                  options={{ 
                  // pageSize: 20,
                  showTitle:false,
                  toolbar: false,
                  sorting: false,
                  paging: false,
                  //  tableLayout: 'fixed',
                  headerStyle: {...stElemnt.CurrH,...stElemnt.CH,backgroundColor:isPurches?"#008080":isStock?"#3f51b5": colors.green[300]},
                  cellStyle: stElemnt.CurR,
    
                   maxBodyHeight: Mtb.minmaxBHCurr,
                   minBodyHeight: Mtb.minmaxBHCurr,
                 }}
                 localization={{ body:{
               
                    emptyDataSourceMessage:<h2
                    style={{
                      overflowY: 'none', /* Hide vertical scrollbar */
                      overflowX: 'none', /* Hide horizontal scrollbar */
                      scrollbarWidth: 'none',
                      scrollbarWidth: 'thin',
                      scrollbarWidth: 'auto',
                    }}
                    ></h2> },
                  }}
    
                 columns={columnsCurr}
                 data={itmData}
                 icons={tableIcons}
                 
                 onRowClick={(event, rowData) => {

                    onRowClicks(rowData);
                  event.stopPropagation();
                }}
                />
    )
}

export default ItemsInvTable;